export default __webpack_public_path__ + "static/media/imatge-slider-portada-4.805731ae.jpg";